import { render, staticRenderFns } from "./Retencioncomponent.vue?vue&type=template&id=8d5afcd6&scoped=true"
import script from "./Retencioncomponent.vue?vue&type=script&lang=js"
export * from "./Retencioncomponent.vue?vue&type=script&lang=js"
import style0 from "./Retencioncomponent.vue?vue&type=style&index=0&id=8d5afcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5afcd6",
  null
  
)

export default component.exports